import React from 'react';
import styled, { css } from 'styled-components';
import { COLORS, sp } from '../styles';

export type PillType = 'info' | 'success' | 'warning' | 'error' | 'neutral';

const variants: Record<
    PillType,
    { bg: string; fg: string; border: string }
> = {
    info: {
        bg: COLORS.pillInfoBg,
        fg: COLORS.pillInfoFg,
        border: COLORS.pillInfoBorder,
    },
    success: {
        bg: COLORS.pillSuccessBg,
        fg: COLORS.pillSuccessFg,
        border: COLORS.pillSuccessBorder,
    },
    warning: {
        bg: COLORS.pillWarningBg,
        fg: COLORS.pillWarningFg,
        border: COLORS.pillWarningBorder,
    },
    error: {
        bg: COLORS.pillErrorBg,
        fg: COLORS.pillErrorFg,
        border: COLORS.pillErrorBorder,
    },
    neutral: {
        bg: COLORS.pillNeutralBg,
        fg: COLORS.pillNeutralFg,
        border: COLORS.pillNeutralBorder,
    },
};

const Wrapper = styled.div<{ type: PillType }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-block-size: ${sp(3)};
    padding: ${sp(0.75)} ${sp(1.25)};
    border-radius: 999px;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid;
    ${({ type }) => {
        const v = variants[type];
        return css`
            background-color: ${v.bg};
            color: ${v.fg};
            border-color: ${v.border};
        `;
    }}
`;

interface PillProps {
    label: string;
    type: PillType;
}

const Pill: React.FC<PillProps> = ({ label, type }) =>
    label ? <Wrapper type={type}>{label}</Wrapper> : null;

export default Pill;
